// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-0c2ea1c1]:export{primaryColor:#4933da;secondaryColor:#d4009f;accentColor:#96ff73;textColor:#333}", ""]);
// Exports
module.exports = exports;
